import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { currencyFormatter, percentageFormatter } from 'helpers/formatHelper';
import { MultiYearsComparisonRow } from 'routes/BudgetModule/components/BudgetOverview/BudgetSynthesisAndRatios/MultiYearsComparison/types';
import HeaderTooltip from 'routes/BudgetModule/components/BudgetOverview/BudgetSynthesisAndRatios/MultiYearsComparison/components/HeaderTooltip';

type Params = CellRendererParams<
    MultiYearsComparisonRow,
    MultiYearsComparisonRow[number]
> & {
    colored: boolean;
};

export default function MultiYearsAmountCellRenderer({
    value,
    colored,
    valueFormatted,
}: Params): React.ReactElement {
    // In one column, the values can be different (string, euro or percentage).
    // Therefore, we need to make different cases to handle that.
    const dataValue = value?.value;
    if (!valueFormatted || dataValue == null) return <></>;
    const isPercentage = value?.type === 'percentage';
    const tooltip = isPercentage
        ? percentageFormatter(dataValue, {
              maximumFractionDigits: 4,
          })
        : currencyFormatter(dataValue, { compact: false });

    return (
        <HeaderTooltip
            tooltip={tooltip}
            colored={colored}
            formattedValue={valueFormatted}
        />
    );
}
